
export default function Keyword(props) {
    return <div className="mr-1 p-2 px-3 keyword">{props.keyword}</div>
}